import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAttendances() {
    try {
        const response = await apiGet('core', `attendance`);
        return response;
    } catch (e) { }
}


export async function getAttendance(id: string) {
    try {
        const response = await apiGet('core', `attendance/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}

export async function addAttendance(body: any) {
    const response = await apiPost('core', `attendance`, body);
    return response;
}

export async function updateAttendance(body: any, id: string) {
    const response = await apiPut('core', `attendance/${id}`, body);
    return response;
}

export async function removeAttendance(id: any) {
    try {
        return await apiDelete('core', `attendance/${id}`);
    } catch (e) { }
}